module.exports = __webpack_public_path__ + "img/svg/background-about-us-mobile.68c43b865a813b66c3a8bf12d600ac0c.svg";